var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIn = function SvgIn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21778_20395",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21778_20395)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#307D44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 6.66667,
    height: 20,
    transform: "rotate(90 20 0)",
    fill: "#F37338"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6.66602,
    width: 6.66667,
    height: 20,
    transform: "rotate(90 20 6.66602)",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13ZM10.0021 12.5205C11.3939 12.5205 12.5221 11.3922 12.5221 10.0005C12.5221 8.60871 11.3939 7.48047 10.0021 7.48047C8.61039 7.48047 7.48214 8.60871 7.48214 10.0005C7.48214 11.3922 8.61039 12.5205 10.0021 12.5205Z",
    fill: "#00007D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1537 9.48128C10.1241 9.47263 10.0936 9.46643 10.0622 9.46292C10.0562 8.3631 10.0323 7.54102 10.0036 7.54102C9.97501 7.54102 9.95107 8.36287 9.94508 9.46245C9.91288 9.4658 9.88151 9.47197 9.85124 9.48072C9.42479 8.46681 9.08802 7.71636 9.06157 7.72732C9.03512 7.73827 9.3276 8.50695 9.74295 9.52534C9.71433 9.54098 9.68727 9.55914 9.66209 9.57952C8.88019 8.80609 8.28198 8.24174 8.26173 8.26198C8.24149 8.28223 8.80595 8.88056 9.57951 9.66257C9.56006 9.6869 9.54266 9.71295 9.52759 9.74045C8.50941 9.32519 7.74095 9.0328 7.72999 9.05924C7.71904 9.08569 8.46922 9.42234 9.48285 9.84868C9.47411 9.87878 9.46792 9.90997 9.46453 9.94199C8.36488 9.94798 7.54297 9.97192 7.54297 10.0005C7.54297 10.0292 8.36499 10.0531 9.46474 10.0591C9.46829 10.0914 9.47469 10.1229 9.48368 10.1532C8.47011 10.5795 7.71999 10.9162 7.73095 10.9426C7.7419 10.9691 8.5106 10.6766 9.52902 10.2612C9.54443 10.289 9.56223 10.3153 9.58213 10.3398C8.80836 11.122 8.24369 11.7205 8.26394 11.7408C8.28419 11.761 8.88293 11.1962 9.66535 10.4222C9.68951 10.4414 9.71536 10.4586 9.74263 10.4736C9.32686 11.4929 9.034 12.2626 9.06047 12.2735C9.08693 12.2845 9.42409 11.5331 9.85092 10.5183C9.88128 10.5271 9.91275 10.5333 9.94506 10.5366C9.95103 11.6377 9.97499 12.461 10.0036 12.461C10.0323 12.461 10.0563 11.6375 10.0622 10.5362C10.0937 10.5326 10.1244 10.5264 10.154 10.5177C10.5808 11.5325 10.9179 12.2838 10.9444 12.2728C10.9708 12.2618 10.6779 11.4921 10.2621 10.4726C10.289 10.4577 10.3146 10.4406 10.3385 10.4215C11.1213 11.1959 11.7204 11.7612 11.7407 11.7409C11.761 11.7207 11.1958 11.1216 10.4215 10.3389C10.4415 10.3142 10.4594 10.2877 10.4749 10.2596C11.4945 10.6755 12.2645 10.9685 12.2755 10.942C12.2864 10.9156 11.5349 10.5783 10.5198 10.1514C10.5286 10.1216 10.5348 10.0908 10.5382 10.0591C11.6395 10.0532 12.463 10.0292 12.463 10.0005C12.463 9.9719 11.6396 9.94793 10.5385 9.94197C10.5351 9.91059 10.5291 9.88002 10.5207 9.85048C11.5358 9.42355 12.2874 9.08628 12.2764 9.05981C12.2655 9.03334 11.4957 9.32625 10.4763 9.74206C10.4612 9.71428 10.4437 9.68797 10.4241 9.6634C11.1982 8.8809 11.7632 8.28207 11.7429 8.26181C11.7226 8.24156 11.124 8.80632 10.3417 9.58017C10.3168 9.55995 10.2901 9.54189 10.2618 9.5263C10.6772 8.50779 10.9697 7.739 10.9433 7.72804C10.9168 7.71708 10.5801 8.46745 10.1537 9.48128Z",
    fill: "#00007D"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/in.66b9dabf08896289ed5c777f567d9ac1.svg";